/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents the different states of an employer onboarding invite
 * @export
 */
export const EmployerOnboardingStatus = {
    Ready: 'Ready',
    NotFound: 'NotFound',
    Expired: 'Expired',
    PartiallyCompleted: 'PartiallyCompleted',
    Completed: 'Completed',
    FirebaseExists: 'FirebaseExists'
};
export function instanceOfEmployerOnboardingStatus(value) {
    for (const key in EmployerOnboardingStatus) {
        if (Object.prototype.hasOwnProperty.call(EmployerOnboardingStatus, key)) {
            if (EmployerOnboardingStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function EmployerOnboardingStatusFromJSON(json) {
    return EmployerOnboardingStatusFromJSONTyped(json, false);
}
export function EmployerOnboardingStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function EmployerOnboardingStatusToJSON(value) {
    return value;
}
export function EmployerOnboardingStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
